import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { Stepper } from "../core/Stepper";
import { HouseIcon } from "../core/icons/Icons";
import { useStyles } from "../../useStyles";

export const RemovalReconstructionHousingUnitsForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<ChangeNames.REMOVAL_RECONSTRUCTION_HOUSING_UNITS>();
    return (
        <div style={{ marginTop: 32 }}>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<HouseIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Anzahl der Wohneinheiten
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 28 }}>
                            Geben Sie hier die Anzahl der Wohneinheiten ein.
                        </p>
                        <Stepper
                            allowNegative={false}
                            value={values.removalReconstructionHousingUnits.value.units || 0}
                            onValueChange={v =>
                                setValues(values => {
                                    values.removalReconstructionHousingUnits.value.units =
                                        v.floatValue ||
                                        values.removalReconstructionHousingUnits.value.units;
                                })
                            }
                        />
                    </Fragment>
                }
            />
        </div>
    );
};
